import styled from 'styled-components'
import { Column as BoltColumn, Row as BoltRow, Button as BoltButton } from '@sainsburys-tech/bolt'

const MediaGalleryGridContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`

const Row = styled(BoltRow)`
  border-left: 4px solid ${props => props.theme.color.monochrome.lighter};
  border-top: 4px solid ${props => props.theme.color.monochrome.lighter};
  position: relative;
`

const Column = styled(BoltColumn)`
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  border-right: 4px solid ${props => props.theme.color.monochrome.lighter};
  border-bottom: 4px solid ${props => props.theme.color.monochrome.lighter};
`

const Button = styled(BoltButton)`
  margin-top: 20px;
`

export { MediaGalleryGridContainer, Row, Column, Button }
